// Module
var code = `<div class="loan-details-container" >
  <div class="columns--space-between">
    <div>
      <span>Applied on</span>
      <span>{{\$ctrl.loanApplicationDetails.grantDate}}</span>
    </div>
    <div>
      <span>Product name</span>
      <span>{{\$ctrl.loanApplicationDetails.productName}}</span>
    </div>
    <div>
      <span>Creation type</span>
      <span>{{\$ctrl.loanApplicationDetails.creationType | prettyEnum}}</span>
    </div>
    <div>
      <span>Loan officer</span>
      <span>{{\$ctrl.loanApplicationDetails.officerName}}</span>
    </div>
    <div>
      <span>Loan security</span>
      <span>{{\$ctrl.loanApplicationDetails.loanSecurity}}</span>
    </div>
  </div>
  <div class="columns--space-between">
    <div>
      <span>Principal</span>
      <span>{{\$ctrl.loanApplicationDetails.principalAmount | nxCurrency}}</span>
    </div>
    <div>
      <span>Interest rate</span>
      <span>{{\$ctrl.loanApplicationDetails.interestRate | rate}}</span>
    </div>
    <div>
      <span>Payment interval</span>
      <span>{{\$ctrl.loanApplicationDetails.paymentIntervalName}}</span>
    </div>
    <div>
      <span>Total amortization number</span>
      <span>{{\$ctrl.loanApplicationDetails.totalAmortizationNumber}}</span>
    </div>
    <div>
      <span>Maturity date</span>
      <span>{{\$ctrl.loanApplicationDetails.maturityDate}}</span>
    </div>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal-loan-application-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;